module.exports = __webpack_public_path__ + "img/mile2m-m@2.6c6b100c.jpg";